import { render } from "./AppPortofolio.vue?vue&type=template&id=55156aa9&scoped=true"
import script from "./AppPortofolio.vue?vue&type=script&lang=js"
export * from "./AppPortofolio.vue?vue&type=script&lang=js"

import "./AppPortofolio.vue?vue&type=style&index=0&id=55156aa9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55156aa9"]])

export default __exports__